import IconList from './IconList/IconList';
import IsrvHeaderOption from './IsrvHeaderOption/IsrvHeaderOption'
export default {
    'iServie-iconList': IconList,
    'isrvHeaderOption' : IsrvHeaderOption
}




// WEBPACK FOOTER //
// ./src/widget/HeaderBar/ChildHeader/index.js